var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBallotLight = function SvgBallotLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    fill: "black",
    stroke: "black",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 3,
    d: "M19.45 0.94C20.72 0.94 21.75 1.97 21.75 3.24C21.75 7.09 21.75 16.63 21.75 20.55C21.75 21.63 20.88 22.5 19.8 22.5C16.44 22.5 8.45 22.5 5.12 22.5C3.95 22.5 3 21.55 3 20.38C3 16.49 3 7.18 3 3.35C3 2.02 4.08 0.94 5.42 0.94C8.68 0.94 16.16 0.94 19.45 0.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    strokeWidth: 1,
    d: "M17.07 6C17.27 6 17.43 6.16 17.43 6.35C17.43 6.6 17.44 6.97 17.44 7.22C17.44 7.41 17.28 7.57 17.09 7.58C16.03 7.59 13.23 7.61 12.18 7.63C11.98 7.63 11.82 7.47 11.82 7.27C11.81 7.03 11.81 6.65 11.81 6.41C11.81 6.21 11.96 6.05 12.16 6.05C13.21 6.04 16.02 6.01 17.07 6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    strokeWidth: 1,
    d: "M17.59 9.3C17.82 9.3 18.01 9.49 18.01 9.72C18 9.96 18 10.28 18 10.52C18 10.75 17.81 10.94 17.58 10.94C15.42 10.93 9.33 10.9 7.16 10.9C6.93 10.89 6.75 10.71 6.75 10.48C6.75 10.23 6.75 9.92 6.75 9.67C6.75 9.44 6.94 9.26 7.17 9.26C9.34 9.27 15.42 9.29 17.59 9.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    strokeWidth: 1,
    d: "M17.62 12.5C17.83 12.5 18 12.67 18 12.88C18 13.11 18 13.39 18 13.62C18 13.83 17.83 14 17.62 14C15.44 14 9.31 14 7.13 14C6.92 14 6.75 13.83 6.75 13.62C6.75 13.39 6.75 13.11 6.75 12.88C6.75 12.67 6.92 12.5 7.13 12.5C9.31 12.5 15.44 12.5 17.62 12.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    strokeWidth: 1,
    d: "M17.62 15.5C17.83 15.5 18 15.67 18 15.88C18 16.11 18 16.39 18 16.62C18 16.83 17.83 17 17.62 17C15.44 17 9.31 17 7.13 17C6.92 17 6.75 16.83 6.75 16.62C6.75 16.39 6.75 16.11 6.75 15.88C6.75 15.67 6.92 15.5 7.13 15.5C9.31 15.5 15.44 15.5 17.62 15.5Z"
  })));
};
export { SvgBallotLight as ReactComponent };